"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardType = void 0;
var CardType;
(function (CardType) {
    CardType[CardType["Product"] = 0] = "Product";
    CardType[CardType["Trim"] = 1] = "Trim";
})(CardType = exports.CardType || (exports.CardType = {}));
//# sourceMappingURL=cardType.js.map